/* eslint-disable max-len */
import { useMediaQuery } from '@chakra-ui/media-query';
import { useEffect, useRef } from 'react';
import * as Consts from './consts';
export var useDTRPdom = _ref => {
  var {
    state,
    methods,
    labels,
    disabled
  } = _ref;
  var [isDesktop] = useMediaQuery('(min-width: 62em)');
  var containerRef = useRef(null);
  var dateLabelRef = useRef(null); // picker header

  useEffect(() => {
    if (!state.focusedInput || !containerRef.current) return;
    if (document.getElementById(Consts.HEADER_ELEMENT_ID)) return; // date label

    var dateLabel = document.createElement('span');
    var dateText = document.createTextNode('');
    dateLabel.appendChild(dateText);
    dateLabelRef.current = dateText; // pickup

    var pickupBtn = document.createElement('p');
    pickupBtn.setAttribute('id', 'dtrp-pickup-btn');
    var pickupText = document.createTextNode(labels.start);

    var pickupOnClick = e => {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      methods.setFocusedInput('startDate');
    };

    pickupBtn.setAttribute('class', state.focusedInput === 'startDate' ? 'tab--active' : 'tab--default');
    pickupBtn.appendChild(pickupText);

    if (disabled !== 'startDate') {
      pickupBtn.addEventListener('click', pickupOnClick);
    } // dropoff


    var dropoffBtn = document.createElement('p');
    dropoffBtn.setAttribute('id', 'dtrp-dropoff-btn');
    var dropoffText = document.createTextNode(labels.end);

    var dropoffOnClick = e => {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      methods.setFocusedInput('endDate');
    };

    dropoffBtn.setAttribute('class', state.focusedInput === 'endDate' ? 'tab--active' : 'tab--default');
    dropoffBtn.appendChild(dropoffText);

    if (disabled !== 'endDate') {
      dropoffBtn.addEventListener('click', dropoffOnClick);
    } // root


    var container = document.createElement('header');
    var dateRow = document.createElement('div');
    dateRow.appendChild(pickupBtn);
    dateRow.appendChild(dropoffBtn);
    container.setAttribute('id', Consts.HEADER_ELEMENT_ID);
    container.appendChild(dateRow);
    container.appendChild(dateLabel);
    var node = (isDesktop ? containerRef.current.getElementsByClassName('DayPicker') : document.getElementsByClassName('DateRangePicker_picker__fullScreenPortal')).item(0);
    node == null ? void 0 : node.insertBefore(container, node.firstChild); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.focusedInput, isDesktop, containerRef.current]); // date label within picker

  useEffect(() => {
    if (!dateLabelRef.current) return;
    var value = '';

    if (state.focusedInput === 'startDate') {
      var _state$startDate;

      value = (state == null ? void 0 : (_state$startDate = state.startDate) == null ? void 0 : _state$startDate.clone().hour(state.startTime).format('M/D/YY [-] hh:mm a')) || '';
    } else {
      var _state$endDate;

      value = (state == null ? void 0 : (_state$endDate = state.endDate) == null ? void 0 : _state$endDate.clone().hour(state.endTime).format('M/D/YY [-] hh:mm a')) || '';
    }

    dateLabelRef.current.nodeValue = value;
  }, [dateLabelRef.current, state.endDate, state.endTime, state.focusedInput, state.startDate, state.startTime]); // style focus classes on inputs

  useEffect(() => {
    var _containerRef$current, _dateRangeInputs$, _dateRangeInputs$2;

    if (!(containerRef != null && containerRef.current)) return;
    var dateRangeInputs = (_containerRef$current = containerRef.current) == null ? void 0 : _containerRef$current.getElementsByClassName('DateInput');

    var setFocusedToStartDate = () => {
      var _document$getElementB;

      methods.setFocusedInput('startDate');
      var containerChildren = (_document$getElementB = document.getElementById(Consts.HEADER_ELEMENT_ID)) == null ? void 0 : _document$getElementB.children;
      var pickup = containerChildren == null ? void 0 : containerChildren.item(0);
      var dropoff = containerChildren == null ? void 0 : containerChildren.item(1);
      pickup == null ? void 0 : pickup.setAttribute('class', 'tab--active');
      dropoff == null ? void 0 : dropoff.setAttribute('class', 'tab--default');
    };

    var setFocusedToEndDate = () => {
      var _document$getElementB2;

      methods.setFocusedInput('endDate');
      var containerChildren = (_document$getElementB2 = document.getElementById(Consts.HEADER_ELEMENT_ID)) == null ? void 0 : _document$getElementB2.children;
      var pickup = containerChildren == null ? void 0 : containerChildren.item(0);
      var dropoff = containerChildren == null ? void 0 : containerChildren.item(1);
      dropoff == null ? void 0 : dropoff.setAttribute('class', 'tab--active');
      pickup == null ? void 0 : pickup.setAttribute('class', 'tab--default');
    };

    if (disabled !== 'startDate') dateRangeInputs == null ? void 0 : (_dateRangeInputs$ = dateRangeInputs[0]) == null ? void 0 : _dateRangeInputs$.addEventListener('click', setFocusedToStartDate);
    if (disabled !== 'endDate') dateRangeInputs == null ? void 0 : (_dateRangeInputs$2 = dateRangeInputs[1]) == null ? void 0 : _dateRangeInputs$2.addEventListener('click', setFocusedToEndDate); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDesktop, containerRef.current]); // style btns on focused input change

  useEffect(() => {
    if (!state.focusedInput) return;
    var pickupBtn = document.getElementById('dtrp-pickup-btn');
    var dropoffBtn = document.getElementById('dtrp-dropoff-btn');
    if (!dropoffBtn || !pickupBtn) return;

    if (state.focusedInput === 'startDate') {
      pickupBtn == null ? void 0 : pickupBtn.setAttribute('class', 'tab--active');
      dropoffBtn == null ? void 0 : dropoffBtn.setAttribute('class', 'tab--default');
    }

    if (state.focusedInput === 'endDate') {
      dropoffBtn == null ? void 0 : dropoffBtn.setAttribute('class', 'tab--active');
      pickupBtn == null ? void 0 : pickupBtn.setAttribute('class', 'tab--default');
    }
  }, [state.focusedInput]);
  return {
    state: {
      isDesktop,
      containerRef
    }
  };
};
//# sourceMappingURL=useDTRPdom.js.map